import React from 'react';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga';

 

class Analytics extends React.Component {
    staging = false
    prod_id = 'UA-108285023-5'
    staging_id = 'UA-108285023-4'
    
    constructor(props){
        super(props);
        var x = window.location.protocol
        if (x === 'http:') {
            this.staging = true
        } else if ( window.location.hostname.indexOf( 'webdev' ) > -1 ) {
            this.staging = true
        } else if ( window.location.hostname.indexOf( 'webqa' ) > -1 ) {
            this.staging = true
        } else if ( window.location.hostname.indexOf( 'webtrn' ) > -1 ) {
            this.staging = true
        } else {
            this.staging = false
        }
        if ( this.staging ) {
            ReactGA.initialize( this.staging_id );
        } else {
            ReactGA.initialize( this.prod_id );
        }
        // We don't want to send the pageview yet, because we want to load the club information first.
    }
    componentWillUpdate ({ location, history }) {
        if (location.pathname === this.props.location.pathname) {
            // don't log identical link clicks (nav links likely)
            return;
        }
        // When navigating forward, or hitting the back button.
        if ( history.action === 'PUSH' ||  history.action === 'POP' ){ 
            ReactGA.set({ dimension7: new Date().getTime() });
            ReactGA.pageview( window.location.pathname + window.location.search );
        }
    }
    render () {
        return null;
    }
}

export default withRouter(Analytics);



// WEBPACK FOOTER //
// ./src/components/Analytics/Analytics.js